import { Icon } from 'core-ui';
import { CustomIconComponentProps } from 'src/models/icon';
import ProjectSvg from './svg';

export const ProjectIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProjectSvg} {...props} />
);
